import * as React from 'react';

import { IContentTypes } from '../content.types';

const EmbeddedContent: React.FC<IContentTypes> = ({ title, message }) => {
    return (
        <>
            <h2 className="sitegen-end-of-operation__title-embedded">{title}</h2>
            <div className="sitegen-end-of-operation__content-embedded">{message}</div>
        </>
    );
};

export default EmbeddedContent;
